<template>
  <div>
    <McFilterSelect
      :draggable="false"
      :defaultColumnOrder="defaultFields"
      :currentColumnOrder="fields"
      @setColumn="handleSetColumns"
      @setField="handleFieldShow"
      @handleSelectAllFields="handleSelectAllFields"
    >
      <template #center-section>
        <div class="mc-vehicle-media__view-content-wrapper">
          <p class="mc-general__label">
            {{ $t('media.contentView') }}
          </p>
          <div class="mc-vehicle-media__content-content p-2 teal-300">
            <p class="d-flex gap-1">
              <McCheckbox v-model="groupingBasedOnMediaDate" />
              {{ $t('media.groupingBasedOnMediaTime') }}
            </p>
            <div class="mc-vehicle-media__default-thumbnail-media-config">
              <p>{{ $t('media.defaultThumbnailMedia') }}</p>
              <multiselect
                v-model="cameraModel"
                :options="cameraOptions"
                track-by="key"
                label="label"
                :disabled="!groupingBasedOnMediaDate"
                :placeholder="$t('videoHistory.modalVideoDownload.placeholder.selectCamera')"
                @input="handleInputCamera"
              />
            </div>
          </div>
        </div>
      </template>
    </McFilterSelect>
  </div>
</template>
<script>
import McFilterSelect from '@/components/McFilterSelect'
import McCheckbox from '@/components/McCheckbox'
import Multiselect from 'vue-multiselect'

export default {
  components: {
    McFilterSelect,
    Multiselect,
    McCheckbox,
  },
  props: {
    fields: {
      type: Array,
      required: true,
    },
    defaultFields: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      alwaysChecked: true,
      groupingBasedOnMediaDate: true,
      cameraModel: {
        label: this.$t('trackVideo.camera') + ' ' + 1,
        key: 1,
      },
    }
  },
  computed: {
    cameraOptions() {
      return [
        {
          label: this.$t('trackVideo.camera') + ' ' + 1,
          key: 1,
        },
        {
          label: this.$t('trackVideo.camera') + ' ' + 2,
          key: 2,
        },
        {
          label: this.$t('trackVideo.camera') + ' ' + 3,
          key: 3,
        },
        {
          label: this.$t('trackVideo.camera') + ' ' + 4,
          key: 4,
        },
      ]
    },
  },
  async mounted() {
    const mediaGroupinsState = JSON.parse(localStorage.getItem('mediaGroupingState'))
    if (mediaGroupinsState) {
      this.groupingBasedOnMediaDate = mediaGroupinsState.groupingBasedOnDate
      this.cameraModel = this.cameraOptions.find((item) => item.key === mediaGroupinsState.camera)
      await this.$nextTick()
      this.$store.commit('media/setDefaultCameraThumbnail', this.cameraModel.key)
      this.$store.commit('media/setGroupingBasedOnDate', this.groupingBasedOnMediaDate)
    }
  },
  methods: {
    handleSelectAllFields(value) {},
    handleInputCamera(e) {},
    handleSetColumns(fields) {},
    handleFieldShow(fields) {
      this.$emit('applyConfigFields', fields)
      this.$store.commit('media/setDefaultCameraThumbnail', this.cameraModel.key)
      this.$store.commit('media/setGroupingBasedOnDate', this.groupingBasedOnMediaDate)
      localStorage.setItem('mediaFields', JSON.stringify({ column: fields }))
      localStorage.setItem(
        'mediaGroupingState',
        JSON.stringify({
          camera: this.cameraModel.key,
          groupingBasedOnDate: this.groupingBasedOnMediaDate,
        })
      )
    },
    cloneFields(fields) {
      const finalFields = this.deepClone(fields, 'child')
      finalFields.forEach((item) => {
        if (item.shown === undefined) item.shown = true
      })
      return finalFields
    },
    deepClone(fields, level) {
      const finalFields = []

      fields.forEach((field) => {
        if (level == 'parent') {
          finalFields.push(field)
        } else {
          if (Object.hasOwn(field, 'children')) {
            finalFields.push(...field.children)
          } else {
            finalFields.push(field)
          }
        }
      })
      return finalFields
    },
  },
}
</script>

<style scoped>
.section {
  .mc-general__label {
    font-weight: 600;
  }
}
</style>
